import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/education/writing")({
  component: WritingLayout,
});

function WritingLayout() {
  return <Outlet />;
}